import React, { Component } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import withStyles from '@material-ui/core/styles/withStyles';

import PreviewNotification from 'assets/img/previews/Preview_Android_Notification.png';

import PreviewControls from 'assets/img/previews/Preview_Android.png';
import PreviewBG from 'assets/img/previews/Preview_Android_BG.png';

import styles from 'assets/jss/material-dashboard-pro-react/components/notificationsPreviewStyles';

class NotificationsPreview extends Component {

	state = {
		isVerifiedImageError: false,
		isFraudImageError: false,
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.verifiedImage !== prevProps.verifiedImage && prevState.isVerifiedImageError) {
			this.setState({
				isVerifiedImageError: false,
			});
		}

		if (this.props.fraudImage !== prevProps.fraudImage && prevState.isFraudImageError) {
			this.setState({
				isFraudImageError: false,
			});
		}
	}

	onVerifiedImageError = () => {
		this.setState({
			isVerifiedImageError: true,
		});
	}

	onFraudImageError = () => {
		this.setState({
			isFraudImageError: true,
		});
	}

	render() {
		const {
			isVerifiedImageError,
			isFraudImageError,
		} = this.state;
		const {
			organizationName,
			classes,
			enterpriseName,
			phoneNumber,
			notification,
			unverifiedCall,
			verifiedImage,
			fraudImage,
			defaultVerifiedImage,
			defaultFraudImage,
		} = this.props;
		const currentPhoneNumber = phoneNumber ? `+${phoneNumber}` : '';


		return (
			<GridContainer className={classes.previewDeviceContainer}>
				<GridItem xs={12} sm={12} md={4} className={classes.previewImageAndroid}>
					<img
						src={PreviewNotification}
						alt="Preview Notification"
					/>
					<div className={classes.androidPushNotificationTitle}>
						<span className={classes.firstLine}>{`${enterpriseName} Pre Call Notification`}</span> <br />
					</div>
					<div className={classes.androidPushNotification}>
						<span>{`You will receive a phone call from ${organizationName}`}</span> <br />
						<div className={classes.androidPushNotificationCallPurpose}>
							<span>{notification}</span>
						</div>
					</div>
				</GridItem>
				<GridItem xs={12} sm={12} md={4} className={classes.previewImageAndroid}>
					<img
						className={classes.absoluteImage}
						src={PreviewBG}
						alt="Preview Background"
					/>
					<div className={classes.previewAndroidImageContainer}>
						{
							((verifiedImage || defaultVerifiedImage) && !isVerifiedImageError) &&
							<img
								src={verifiedImage || defaultVerifiedImage}
								onError={this.onVerifiedImageError}
								className={classes.notificationPreviewImageAndroid}
								alt="Verified Logo" />
						}
					</div>
					<img
						className={classes.absoluteImage}
						src={PreviewControls}
						alt="Preview Controls"
					/>
					<div className={classes.androidVerifiedPreviewText}>
						<span>{`${organizationName}`}</span> <br />
						<div className={classes.androidVerifiedMessage}>
							<span>{notification}</span>
						</div>
					</div>
				</GridItem>
				<GridItem xs={12} sm={12} md={4} className={classes.previewImageAndroid}>
					<img
						className={classes.absoluteImage}
						src={PreviewBG}
						alt="Preview background"
					/>
					<div className={classes.previewAndroidImageContainer}>
						{
							((fraudImage || defaultFraudImage) && !isFraudImageError) &&
							<img
								src={fraudImage || defaultFraudImage}
								onError={this.onFraudImageError}
								className={classes.notificationPreviewImageAndroid}
								alt="Fraud Logo"
							/>
						}
					</div>
					<img
						className={classes.absoluteImage}
						src={PreviewControls}
						alt="Preview controls"
					/>
					<div className={classes.androidCall}>
						<span className={classes.androidCallNumber}>{`${currentPhoneNumber}`}</span> <br />
						<span className={classes.androidUnVerifiedMessage}>{unverifiedCall}</span>
					</div>
				</GridItem>
			</GridContainer>
		)
	}
}

export default withStyles(styles)(NotificationsPreview);